function familyTree(arr1, id) {
  let temp = [];
  let forFn = function (arr, id) {
    for (let i = 0; i < arr.length; i++) {
      let item = arr[i];
      if (item.id === id) {
        item.expand = true
        temp.push(item);
        forFn(arr1, item.parentId);
        break;
      } else {
        // item.selected = false
        if (item.children && item.children.length > 0) {
          forFn(item.children, id);
        }
      }
    }
  };
  forFn(arr1, id);
  return temp.reverse();
}
//设置tree选中 根据id匹配
function dealCheckTree(id, arr) {
  for (let item of arr) {
    if (item.id === id) {
      item.selected = true
    } else {
      item.selected = false
    }
    if (item.children && item.children.length > 0) {
      dealCheckTree(id, item.children)
    }
  }
}
export const mutations = {
  //设置组织信息
  setMechOranization(state, data) {
    state.mechOranization = data
  },
  //设置面包屑
  setMechNavList(state, data) {
    if (data.mechTreeList && data.mechTreeList.length) {
      state.mechTreeList = data.mechTreeList
    }
    if (!data.id) {
      return;
    }
    state.currentTreeId = data.id
    //当前id对应树选中。。。
    dealCheckTree(data.id, state.mechTreeList)
    state.mechNavList = familyTree(state.mechTreeList, data.id); //面包屑
  },
  //新增业务员缓存编号
  setBatchNo(state, data) {
    state.batchNo = data
  },
  setUserInfo(state, data) {
    state.userInfo = data
  },

  setAllAgreeCompany(state, data) {
    state.allAgreeCompany = data.map(item => ({
      label: item.companyName,
      value: item.companyId
    }));
  },
  setBaseInfo(state,data){
    state.baseInfo = data
    sessionStorage.setItem('baseInfo',JSON.stringify(data))
  },
  changeBaseInfoStatus(state,data) {
    state.baseInfo.status = data;
    sessionStorage.setItem('baseInfo',JSON.stringify(state.baseInfo));
  },
  setInsureItems(state,data){
    state.insureItems = data
    sessionStorage.setItem('insureItems',JSON.stringify(data))
  },
  setInsureItemsPersonal(state,data){
    state.insureItemsPersonal = data
    sessionStorage.setItem('insureItemsPersonal',JSON.stringify(data))
  },
  setCompareDTOS(state,data){
    state.compareDTOS = data
    sessionStorage.setItem('compareDTOS',JSON.stringify(data))
  },
  setCompareVOS(state,data){
    state.compareVOS = data
    sessionStorage.setItem('compareVOS',JSON.stringify(data))
  },
  setPolicies(state,data){
    state.policies = data
    sessionStorage.setItem('policies',JSON.stringify(data))
  },
  setRequestId(state,data) {
    state.requestId = data;
  }
}
